import { NewMediaService } from './new-media-service';

export default NewMediaService;
